import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";

function AddAccountHead() {
    const [editId, setEditId] = useState(null);
    const routeLocation = useLocation();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [groups, setGroups] = useState([]);
    const [form, setForm] = useState({
        group_id: "",
        group_code: "",
        account_head_name: "",
        account_head_code: "",
    });

    useEffect(() => {
        fetchGroups();
    }, []);

    useEffect(() => {
        if (routeLocation.state?.accountHeadData) {
            const accountHeadData = routeLocation.state.accountHeadData;
            setForm({
                group_id: accountHeadData.group_id || "",
                group_code: accountHeadData.group_code || "",
                account_head_name: accountHeadData.account_head_name || "",
                account_head_code: accountHeadData.account_head_code || "",
            });
            setEditId(accountHeadData.account_head_id);
            window.history.replaceState({}, document.title);
        }
    }, [routeLocation]);

    const fetchGroups = async () => {
        try {
            const response = await axios.post(baseUrl + "/groupsfilter/", {
                school_id: userObj.school_id,
                group_id: null,
                parent_group_id: null,
                group_name: null,
                group_code: null,
            });
            setGroups(response.data || []);
        } catch (error) {
            console.error("Error fetching groups:", error);
        }
    };

    const handleGroupChange = (e) => {
        const selectedGroupId = e.target.value;
        const selectedGroup = groups.find(g => String(g.group_id) === String(selectedGroupId));
        setForm((prevForm) => ({
            ...prevForm,
            group_id: selectedGroupId,
            group_code: selectedGroup ? (selectedGroup.group_code || "") : "",
        }));
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            account_head_name: form.account_head_name,
            account_head_code: form.account_head_code || null,
            group_id: form.group_id ? parseInt(form.group_id) : null,
            school_id: userObj.school_id,
            user: userObj.user_name,
        };

        try {
            if (editId !== null) {
                await axios.put(`${baseUrl}/account-head/${editId}`, payload, {
                    headers: { "Content-Type": "application/json" },
                });
                toast.success("Record Updated Successfully");
            } else {
                await axios.post(baseUrl + "/account-head/", payload, {
                    headers: { "Content-Type": "application/json" },
                });
                toast.success("Record Added Successfully");
            }
            setForm({ group_id: "", group_code: "", account_head_name: "", account_head_code: "" });
            setEditId(null);
        } catch (error) {
            console.error("Error submitting data:", error.response?.data || error.message);
            if (error.response?.data?.error?.includes("already exists")) {
                toast.error("Record already exists");
            } else {
                toast.error("Unexpected error occurred");
            }
        }
    };

    return (
        <div className='pageBody'>
            <ToastContainer />
            <Container fluid>
                <div className=''>
                    <Card>
                        <Card.Body>
                            <form className="" onSubmit={handleSubmit}>
                                <div className=''>
                                    <Row>
                                        <Col xs={12}>
                                            <h6 className='commonSectionTitle'>Account Head Details</h6>
                                        </Col>
                                    </Row>
                                    <Row>

                                        {/* 1. Group Name Dropdown */}
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>Group Name</Form.Label>
                                                    <Form.Select
                                                        id="group_id"
                                                        value={form.group_id}
                                                        onChange={handleGroupChange}
                                                    >
                                                        <option value="">Select Group Name</option>
                                                        {groups
                                                            .filter((g) => g.is_active === "Active")
                                                            .map((g) => (
                                                                <option key={g.group_id} value={g.group_id}>
                                                                    {g.group_name}
                                                                </option>
                                                            ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        {/* 2. Group Code - auto-filled, read-only */}
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>Group Code</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="group_code"
                                                        value={form.group_code}
                                                        placeholder="Auto-filled on group selection"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        {/* 3. Account Head Name */}
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>Account Head Name <span className='requiredStar'>*</span></Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="account_head_name"
                                                        value={form.account_head_name}
                                                        placeholder="Enter Account Head Name"
                                                        maxLength={100}
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Control.Feedback>Required</Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </Col>

                                        {/* 4. Account Head Code */}
                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>Account Head Code</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        id="account_head_code"
                                                        value={form.account_head_code}
                                                        placeholder="Enter Account Head Code"
                                                        maxLength={50}
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>

                                    </Row>
                                </div>

                                <div className="d-flex justify-content-between mt-3">
                                    <div>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="btn-info clearBtn"
                                            onClick={() => setForm({ group_id: "", group_code: "", account_head_name: "", account_head_code: "" })}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="btn-danger secondaryBtn me-2"
                                            onClick={() => window.history.back()}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            className="btn-success primaryBtn"
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </form>
                        </Card.Body>
                    </Card>
                </div>
            </Container>
        </div>
    );
}

export default AddAccountHead;